import type { EmployeeLookup } from './types'

export function personSearchValue(person: EmployeeLookup): string {
  return [person.firstName, person.lastName, person.employeeCode, person.email, person.mobileNumber]
    .filter(Boolean)
    .join(' ')
}
